export const handleFormatDate = (
  date = new Date(),
  isTime = false,
  isReverse = true
) => {
  let formatDate = "";
  if (date) {
    let fDate = `${date.getFullYear()}-${
      date.getMonth() + 1
    }-${date.getDate()}`;
    let fTime = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
    if (isTime) {
      formatDate = `${fDate} ${fTime}`;
    } else {
      formatDate = fDate;
    }
    if (isReverse) {
      let fDate = `${date.getDate()}-${
        date.getMonth() + 1
      }-${date.getFullYear()}`;
      formatDate = fDate;
    }
  }
  return formatDate;
};
